import { Button } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
import useOption from 'components/customHooks';
import './RatingsPopup.css';
import RatingsLine from './RatingsLine';
import PopupButtons from './PopupButtons';
const RatingsPopup = ({ data, hasOverride, isDisabled, save }) => {
    const [ratings, setRatings] = React.useState(() => {
        const values = data?.override?.ratings?.values ?? data?.data?.ratings?.values ?? [];
        if (!values.some(v => v.agency === 'MOODYS'))
            values.push({ value: '', agency: 'MOODYS' });
        if (!values.some(v => v.agency === 'S_P'))
            values.push({ value: '', agency: 'S_P' });
        if (!values.some(v => v.agency === 'FITCH'))
            values.push({ value: '', agency: 'FITCH' });
        return { values };
    });
    const agencyOptions = useOption('/syndicate/overview/rating-agency/options', { sort: false });
    React.useEffect(() => {
        const index = (agency) => {
            const index = agencyOptions.findIndex(o => 'value' in o && o.value === agency);
            return index > -1 ? index : 999;
        };
        setRatings((existingRatings) => {
            const { values } = existingRatings;
            return { values: values === undefined ? [] : [...values].sort((a, b) => index(a.agency) - index(b.agency)) };
        });
    }, [agencyOptions]);
    const onClickAdd = React.useCallback(() => {
        setRatings((existingRatings) => {
            const clone = existingRatings.values !== undefined ? [...existingRatings.values] : [];
            clone.push({ value: '' });
            return { values: clone };
        });
    }, []);
    const onChangeRating = React.useCallback((index) => (rating) => {
        setRatings((existingRatings) => {
            const clone = existingRatings.values !== undefined ? [...existingRatings.values] : [];
            clone[index] = rating;
            return { values: clone };
        });
    }, []);
    const finalRatings = React.useMemo(() => ({ values: ratings.values?.filter(v => v.value !== '') }), [ratings]);
    const currentAgencies = React.useMemo(() => (ratings.values ?? []).map(r => r.agency), [ratings]);
    return React.createElement(React.Fragment, null,
        ratings.values?.map((r, index) => (React.createElement(RatingsLine, { agencyOptions: agencyOptions, currentAgencies: currentAgencies, isDisabled: isDisabled, key: r.agency ?? "NONE" + index.toString(), onChange: onChangeRating(index), rating: r }))),
        React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem' } },
            React.createElement(Button, { size: "small", onClick: onClickAdd }, "ADD"),
            React.createElement(PopupButtons, { value: finalRatings, hasOverride: hasOverride, save: save, isDisabled: isDisabled })));
};
export default RatingsPopup;
